import keymirror from "../utils/keymirror";

export const LoginConstants = keymirror(
    {
        LOGIN: null,
        LOGIN_SUCCESS: null,
        LOGIN_FAILURE: null,

        LOGOUT: null,
        RECEIVED_ID_TOKEN: null,
        RECEIVED_API_TOKEN: null,
        CHECK_API_TOKEN: null,
        UPDATE_USER_SETTINGS: null,

        INITIATE_LOGIN_CHECK: null
    },
    "login"
);



// WEBPACK FOOTER //
// ./src/constants/login.constants.js